module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/plus-grey-icon-d4295dd1.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/plus-grey-icon.svg
// module id = ./app/web/src/assets/plus-grey-icon.svg
// module chunks = 0